import { Box, HStack, Spinner, Stack } from "@chakra-ui/react"
import { Text } from "@/components"
import { useQuery } from "@tanstack/react-query"
import { getCompanyFiles, type CompanyFile } from "@/api/companies"

interface Props {
  companyId: number
}

export const CompanyFiles = ({ companyId }: Props) => {
  const { data: files, isLoading } = useQuery<CompanyFile[]>({
    queryKey: ["companyFiles", companyId],
    queryFn: () => getCompanyFiles(companyId),
    staleTime: 1000 * 60 * 5,
  })

  if (isLoading) {
    return (
      <HStack justifyContent="center" py={8} gap={2}>
        <Spinner size="sm" />
        <Text fontSize="sm" color="text.muted">Loading files...</Text>
      </HStack>
    )
  }

  if (!files || files.length === 0) {
    return (
      <Text fontSize="sm" color="text.muted" py={6} textAlign="center">No files found in Dropbox</Text>
    )
  }

  return (
    <Stack gap={2}>
      {files.map((file, i) => (
        <HStack
          key={`${file.name}-${i}`}
          p={3}
          borderRadius="md"
          border="1px solid"
          borderColor="border.default"
          cursor="pointer"
          _hover={{ bg: "hover.bg" }}
          onClick={() => window.open(`${process.env.REACT_APP_SERVER_URL}/companies/${companyId}/files/preview/${encodeURIComponent(file.name)}`, "_blank")}
          justifyContent="space-between"
          gap={3}
        >
          <HStack gap={3} minW={0} flex={1}>
            <Box
              as="span"
              fontSize="xs"
              fontWeight="bold"
              color="gray.500"
              bg="gray.100"
              px={2}
              py="2px"
              borderRadius="sm"
              _dark={{ bg: "gray.700", color: "gray.300" }}
              whiteSpace="nowrap"
              flexShrink={0}
            >
              {file.type || "FILE"}
            </Box>
            <Text fontSize="sm" fontWeight="medium" truncate>{file.name}</Text>
          </HStack>
          <Text fontSize="xs" color="text.muted" whiteSpace="nowrap" flexShrink={0}>
            {file.date ? new Date(file.date).toLocaleDateString() : "\u2014"}
          </Text>
        </HStack>
      ))}
    </Stack>
  )
}
